import styled, { css } from 'styled-components';
import { colors } from 'global/colors';

export const TrophyIcon = styled.div`
  ${(props) =>
    props.itemColor &&
    css`
      width: 32px;
      height: 32px;
      border-radius: 50%;
      position: relative;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
      box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.3);
      position: absolute;
      left: 0;

      &:before {
        content: '';
        position: absolute;
        background: ${colors.fsLightBlue};
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        z-index: -1;
      }

      &:after {
        content: '\f091';
        font-family: 'FontAwesome';
        position: absolute;
        color: white;
        opacity: 0.75;
        font-size: 16px;
      }

      ${(props) =>
        props.itemColor === 'gold' &&
        css`
          background: linear-gradient(-45deg, rgb(240, 199, 0), rgba(240, 199, 0, 0.2), rgb(240, 199, 0));
          border: 1px solid rgb(240, 199, 0);
        `}

      ${(props) =>
        props.itemColor === 'silver' &&
        css`
          background: linear-gradient(-45deg, rgb(112, 112, 112), rgba(112, 112, 112, 0.2), rgb(112, 112, 112));
          border: 1px solid rgb(112, 112, 112);
        `}

      ${(props) =>
        props.itemColor === 'bronze' &&
        css`
          background: linear-gradient(-45deg, rgb(214, 129, 0), rgba(214, 129, 0, 0.2), rgb(214, 129, 0));
          border: 1px solid rgb(214, 129, 0);
        `}
      ${(props) =>
        props.itemColor === 'iron' &&
        css`
          background: linear-gradient(-45deg, rgb(0, 184, 184), rgba(0, 184, 184, 0.2), rgb(0, 184, 184));
          border: 1px solid rgb(0, 184, 184);

          &:after {
            content: '\f21e';
            font-family: 'FontAwesome';
            position: absolute;
            color: white;
            opacity: 0.75;
            font-size: 16px;
          }
        `}
    `}
`;

export const SortArrows = styled.img`
  height: 10px;
  width: 10px;
  margin-left: 5px;
  cursor: pointer;
`;

export const TableTitle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  ${(props) =>
    props.isScore &&
    css`
      cursor: pointer;
    `}

  ${(props) =>
    props.isHash &&
    css`
      padding-right: 0px !important;
      padding-left: 30px !important;
    `}
`;

export const ChallengeTableHeader = styled.div`
  margin-right: 0 !important;
  margin-left: 0 !important;
  width: 100%;

  ${(props) =>
    css`
      background-color: ${props.ineligible ? colors.lightRed5 : props.isGrey ? colors.lightGray : colors.white};
    `}
`;

export const NameLink = styled.a`
  color: #212529;
  text-decoration: none;

  &:hover {
    color: #212529;
    text-decoration: none;
  }
`;

export const TotalSubmits = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: center;
  height: 100%;
`;

export const ViewGameContainer = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
`;

export const RankListPlayerContainer = styled.div`
  margin-bottom: 1px;
`;

export const TrendIcon = styled.i.attrs(({ icon }) => ({
  className: icon,
}))`
  font-size: ${(props) => (props.isHackathon ? '40px' : '19px')};
  float: left;
  position: absolute;
  left: ${(props) => (props.isHackathon ? '0px' : '40px')};
  @media (max-width: 768px) {
    display: none;
  }

  ${({ isUp }) =>
    isUp &&
    css`
      color: ${colors.green2};
    `}

  ${({ isDown }) =>
    isDown &&
    css`
      color: ${colors.red};
    `}

    ${({ isConstant }) =>
    isConstant &&
    css`
      color: ${colors.lightGray2};
    `}
`;

export const LanguageIcon = styled.i.attrs(({ className }) => ({
  className: className,
}))`
  ${({ isHackathon }) =>
    isHackathon &&
    css`
      font-size: 40px;
    `}
`;
